import { useTheme } from 'styled-components'

import { IconBase, IconProps } from './Base'

export const IconRight = (props: IconProps) => {
  const theme = useTheme()

  return (
    <IconBase width={props.width || 16} height={props.height || 17} viewBox="0 0 16 17" fill="none" style={props.style}>
      <path
        d="M6 12.5L10 8.5L6 4.5"
        stroke={props.stroke || theme.colors.text.primary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  )
}
